/*
 * @Author: Chao Yang
 * @Date: 2020-05-20 09:21:43
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-05-20 16:57:06
 */

import { TemplateRef } from '@angular/core';

export class AdTabMenuItem {
  value: string;
  text: string;
  data: any;
  disabled = false;
  textTpl: TemplateRef<any>;
  moveBtnTpl: TemplateRef<any>;
  actived = false;
  cssClass: string;
}
